module.exports = __webpack_public_path__ + "static/media/YM_july.3a6851a5.pdf";